// ABOUTME: Header button that exports the pivot to a multi-sheet .xlsx via a web worker, with a progress toast.
// ABOUTME: Reuses the Shbutton styling from ReportDetailPage; export logic lives in export/runPivotExport.
import { useTheme } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Shbutton from "../../../../theme/buttons/Shbutton";
import { showToastPromise } from "../../../../../utils/toasts";
import { runPivotExport } from "../../export/runPivotExport";

export const RhPivotExportButton = ({ data, currentReport, chartOption }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [busy, setBusy] = useState(false);

    const hidden = chartOption?.pivotHidden || currentReport?.pivotHidden || [];

    const handleExport = () => {
        if (busy || !data || !(data.rows || []).length) return;
        setBusy(true);
        const promise = runPivotExport({ data, currentReport, t, hidden }).finally(() => setBusy(false));
        showToastPromise(promise, t, {
            pending: t("exporting"),
            success: t("export_ready"),
            error: t("export_failed"),
        });
    };

    return (
        <Shbutton
            isLoading={busy}
            onClick={handleExport}
            variant="contained"
            color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
            startIcon={<FileDownloadOutlinedIcon />}
            sx={{
                whiteSpace: "nowrap",
                px: 3,
                minWidth: "unset",
            }}
        >
            {t("export")}
        </Shbutton>
    );
};
